(function () {
  var desktopQuery = window.matchMedia('(min-width: 750px)');
  var states = new WeakMap();

  function isSearchInput(input) {
    return input && input.matches &&
      input.matches('.search-bar__form input[name="q"], .cp-search input[name="q"], .cp-compact-header__search input[name="q"]');
  }

  function clearResults(menu) {
    if (!menu) return;
    menu.replaceChildren();
    menu.hidden = true;
  }

  function getMenu(input) {
    var form = input.closest('.search-bar__form, .cp-search, .cp-compact-header__search');
    if (!form) return null;
    var wrapper = form.querySelector('.search-form__input-wrapper') || form;
    var menu = wrapper.querySelector('.cp-desktop-predictive-results');
    if (menu) return menu;

    menu = document.createElement('div');
    menu.className = 'cp-desktop-predictive-results';
    menu.setAttribute('role', 'listbox');
    menu.setAttribute('aria-label', 'ძიების შედეგები');
    menu.hidden = true;
    wrapper.appendChild(menu);
    return menu;
  }

  function showMessage(menu, messageText) {
    menu.replaceChildren();
    var message = document.createElement('span');
    message.className = 'cp-desktop-predictive-results__empty';
    message.textContent = messageText;
    menu.appendChild(message);
    menu.hidden = false;
  }

  function showProducts(menu, products) {
    menu.replaceChildren();

    if (!products.length) {
      clearResults(menu);
      return;
    }

    products.forEach(function (product) {
      var link = document.createElement('a');
      link.className = 'cp-desktop-predictive-results__item';
      link.href = product.url;
      link.setAttribute('role', 'option');

      if (product.image) {
        var image = document.createElement('img');
        image.className = 'cp-desktop-predictive-results__image';
        image.src = product.image;
        image.alt = product.title;
        link.appendChild(image);
      }

      var title = document.createElement('span');
      title.className = 'cp-desktop-predictive-results__title';
      title.textContent = product.title;
      link.appendChild(title);
      menu.appendChild(link);
    });

    menu.hidden = false;
  }

  function productsFromSearchPage(html) {
    var documentResult = new DOMParser().parseFromString(html, 'text/html');
    var cards = documentResult.querySelectorAll('.list-view-item .product-card--list');
    var products = [];

    cards.forEach(function (card) {
      var link = card.querySelector('.full-width-link');
      var title = card.querySelector('.product-card__title');
      if (!link || !title) return;

      var image = card.querySelector('.list-view-item__image');
      products.push({
        url: link.href,
        title: title.textContent.trim(),
        image: image ? image.src : ''
      });
    });

    return products;
  }

  function runSearch(input, isConfirmed) {
    var menu = getMenu(input);
    var form = input.closest('.search-bar__form, .cp-search, .cp-compact-header__search');
    if (!menu || !form) return;

    var query = input.value.trim();
    if (!query || !desktopQuery.matches) {
      clearResults(menu);
      return;
    }

    var state = states.get(input) || {};
    if (state.controller) state.controller.abort();
    if (state.emptyTimer) window.clearTimeout(state.emptyTimer);
    state.emptyTimer = null;
    state.controller = new AbortController();
    states.set(input, state);

    var endpoint = new URL(form.getAttribute('action') || '/search', window.location.href);
    endpoint.searchParams.set('q', query);
    endpoint.searchParams.set('type', 'product');
    endpoint.searchParams.set('options[prefix]', 'last');

    fetch(endpoint.toString(), {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
      signal: state.controller.signal
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Search request failed');
        return response.text();
      })
      .then(function (html) {
        if (input.value.trim() !== query) return;
        var products = productsFromSearchPage(html);

        if (!products.length) {
          if (isConfirmed) {
            showMessage(menu, 'პროდუქტი ვერ მოიძებნა');
            return;
          }

          state.emptyTimer = window.setTimeout(function () {
            if (input.value.trim() === query) showMessage(menu, 'პროდუქტი ვერ მოიძებნა');
          }, 850);
          states.set(input, state);
          return;
        }

        showProducts(menu, products);
      })
      .catch(function (error) {
        if (error.name !== 'AbortError') showMessage(menu, 'ძიების შედეგები ვერ ჩაიტვირთა. გთხოვთ, სცადეთ კიდევ ერთხელ.');
      });
  }

  function scheduleSearch(input) {
    var state = states.get(input) || {};
    window.clearTimeout(state.timer);
    if (state.emptyTimer) window.clearTimeout(state.emptyTimer);
    state.emptyTimer = null;
    state.timer = window.setTimeout(function () { runSearch(input, false); }, 160);
    states.set(input, state);
  }

  document.addEventListener('input', function (event) {
    if (!desktopQuery.matches || !isSearchInput(event.target)) return;
    scheduleSearch(event.target);
  }, true);

  document.addEventListener('submit', function (event) {
    if (!desktopQuery.matches) return;
    var form = event.target;
    var input = form && form.querySelector && form.querySelector('input[name="q"]');
    if (!isSearchInput(input)) return;
    event.preventDefault();
    runSearch(input, true);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !isSearchInput(event.target)) return;
    clearResults(getMenu(event.target));
  }, true);

  document.addEventListener('click', function (event) {
    document.querySelectorAll('.cp-desktop-predictive-results').forEach(function (menu) {
      if (!menu.parentElement.contains(event.target)) clearResults(menu);
    });
  });
})();